import React from 'react';
// import { ALL_ICONS_IN_ALL_CONTEXTS } from 'semantic-ui-react/src/lib/SUI';
import { Icon, Input, Popup } from 'semantic-ui-react';

import css from './style.module.scss';

import ALL_ICONS_IN_ALL_CONTEXTS from '@/utils/lists/icons';

const AVAIL_COLORS = [
  'unset',
  '#444444',
  '#999999',
  '#4B98FB',
  '#4DB2D3',
  '#23B164',
  '#F59E0B',
  '#EF4444',
  '#ED698F',
  '#5856EC',
];

const COLOR_NAMES = {
  'unset': 'System color',
  '#444444': 'Black',
  '#999999': 'Gray',
  '#4B98FB': 'Bright blue',
  '#4DB2D3': 'Blue',
  '#23B164': 'Green',
  '#F59E0B': 'Orange',
  '#EF4444': 'Red',
  '#ED698F': 'Pink',
  '#5856EC': 'Purple',
};

const DEFAULT_ICON_VALUE = { icon: 'info', color: 'unset' };

export default function IconSelector (props) {

  const [opened, setOpened] = React.useState(false);
  const [searching, setSearching] = React.useState('');

  const {
    name = "unnamed icon input",
    onChange = _ => {},
    value = DEFAULT_ICON_VALUE,
    noColors = false,
    label,
    ...other
  } = props;

  function onSearchChange (event, target) {
    setSearching(target.value);
  }

  function onColorChange (event) {
    const localValue = {
      icon: value?.icon || DEFAULT_ICON_VALUE.icon,
      color: event.target.value
    };
    const target = { name, value: localValue };
    onChange(event, target);
  }

  function onIconChange (iconName) {
    const localValue = {
      icon: iconName,
      color: value?.color || DEFAULT_ICON_VALUE.color
    };
    const target = { name, value: localValue };
    onChange(iconName, target);
    setOpened(false);
  }

  return <div className={'field'}>
    <label>{label || 'Icon'}</label> { }
    {/* <InputControl
      type="text"
      fieldProps={{
        label: { tag: true, content: 'Change icon' },
        icon: 'tags'
      }}
    /> */}
    <div className={css['the-input-container']}>
      <Popup
        on='click'
        open={opened}
        position='bottom left'
        onClose={_ => { setOpened(false); }}
        trigger={
          <Input
            icon={value?.icon || DEFAULT_ICON_VALUE.icon}
            size='large'
            iconPosition='left'
            className={css['field']}
            style={{color: value.color || DEFAULT_ICON_VALUE.color}}
            readOnly
            onBlur={_ => {
              setTimeout(_ => {
                setOpened(false);
              }, 250);
            }}
            label={{
              tag: true,
              content: 'Change icon',
              className: 'the-label',
              onClick: _ => {
                setOpened(!opened);
              }
            }}
            value={value?.icon || DEFAULT_ICON_VALUE.icon}
            onClick={_ => {
              setOpened(!opened);
            }}
            labelPosition='right'
            placeholder='Select an icon'
          />
        }
        content={<div className={css['popup-container']}>
          <div className={css['header']}>
            <Input
              type="search"
              icon="search"
              onChange={onSearchChange}
              value={searching}
            />
            <div className={css['colors']}>
              {
                !noColors && AVAIL_COLORS.map(c => {
                  return (
                    <button
                      key={c}
                      className={css['color']}
                      style={{color: c}}
                      data-active={value?.color === c ? 1 : null}
                      value={c}
                      title={COLOR_NAMES[c]}
                      onClick={onColorChange}
                    />
                  );
                })
              }
            </div>
          </div>
          <hr/>
          <div className={css['icons-list-container']}>
            {
              ALL_ICONS_IN_ALL_CONTEXTS
                .filter(name => !searching || name.indexOf(searching) > -1)
                .map(iconOption => {
                  return (
                    <button
                      key={iconOption}
                      title={iconOption}
                      value={iconOption}
                      onClick={_ => onIconChange(iconOption)}
                      className={css['icon-item']}
                      style={{color: value?.color || DEFAULT_ICON_VALUE.color}}
                    >
                      <Icon
                        name={iconOption}
                        size="huge"
                        className={css['icon']}
                      />
                      <span>{iconOption}</span>
                    </button>
                  );
                })
            }
          </div>
        </div>}
      />
    </div>
  </div>;
}